import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ changedValue }) {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };
  const generateRandomArray = (length, min, max) => {
    const arr = [];
    for (let i = 0; i < length; i++) {
      arr.push(Math.floor(Math.random() * (max - min + 1)) + min);
    }
    return arr;
  };
  // generate 11 random hex colors array for the chart
  function generateShades(hex, steps = 11) {
    const hexToRgb = (hex) => {
      const bigint = parseInt(hex.slice(1), 16);
      return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
      };
    };

    const rgbToHex = ({ r, g, b }) => {
      const toHex = (c) => c.toString(16).padStart(2, "0");
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

    const interpolateColor = (color, factor) => {
      return {
        r: Math.round(color.r + (255 - color.r) * factor),
        g: Math.round(color.g + (255 - color.g) * factor),
        b: Math.round(color.b + (255 - color.b) * factor),
      };
    };

    const base = hexToRgb(hex);
    const result = [];

    // from darker (0.5) to lighter (1.0), evenly spaced
    for (let i = 0; i < steps; i++) {
      const factor = i / (steps - 1); // 0 to 1
      const shade = interpolateColor(base, factor * 1); // 0.0 to 0.5 blending to white
      result.push(rgbToHex(shade));
    }

    return result;
  }

  // Usage
  const shades = generateShades("#12805e");
  const [data, setData] = useState({
    labels: [
      "2025",
      "2026",
      "2027",
      "2028",
      "2029",
      "2030",
      "2031",
      "2032",
      "2033",
      "2034",
      "2035",
    ],
    datasets: [
      {
        label: "# of Asset",
        data: generateRandomArray(11, 0, 12),
        borderColor: "#12805e",
        backgroundColor: shades,
      },
    ],
  });

  useEffect(() => {
    if (changedValue > 0) {
      setData({
        labels: ["Excellent", "Good", "Fair", "Poor", "Critical"],
        datasets: [
          {
            label: "# of Asset",
            data: generateRandomArray(5, 0, 7),
            borderColor: themeColor,
            backgroundColor: [
              "#12805e",
              "#5cb85c",
              "#5bc0de",
              "#f0ad4e",
              "#d9534f",
            ],
          },
        ],
      });
    }
  }, [changedValue]);

  return data ? (
    <div style={{ position: "relative", height: "434px", width: "100%" }}>
      <Doughnut options={options} data={data} />
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}
export default App;
